var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.product.id
    ? _c(
        "div",
        {
          staticClass: "ProductItem",
          staticStyle: {
            visibility: "inherit",
            opacity: "1",
            transform: "matrix(1, 0, 0, 1, 0, 0)",
          },
        },
        [
          _c("div", { staticClass: "ProductItem__Wrapper" }, [
            _c(
              "a",
              {
                staticClass: "ProductItem__ImageWrapper",
                attrs: { href: _vm.product.url },
              },
              [
                _c(
                  "div",
                  { staticClass: "AspectRatio" },
                  _vm._l(_vm.product.images, function (image, idx) {
                    return _c("img", {
                      key: idx,
                      staticClass:
                        "ProductItem__Image Image--lazyLoad Image--fadeIn",
                      attrs: { src: image.src, alt: image.alt },
                    })
                  }),
                  0
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ProductItem__LabelList" }, [
              _vm.product.sold_out === "present"
                ? _c("div", { staticClass: "label sold-out" }, [
                    _c("p", { staticClass: "label__text" }, [
                      _vm._v(_vm._s(_vm.store_availability.general.sold_out)),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.sold_out !== "present" && _vm.product.discount
                ? _c("div", { staticClass: "label discount" }, [
                    _c("p", { staticClass: "label__text" }, [
                      _vm._v("Spar " + _vm._s(_vm.product.discount) + " %"),
                    ]),
                  ])
                : _vm.product.new_item === "present"
                ? _c("div", { staticClass: "label new-item" }, [
                    _c("p", { staticClass: "label__text" }, [_vm._v("Nyhed")]),
                  ])
                : _vm.product.members_discount === "present"
                ? _c("div", { staticClass: "label members-discount" }, [
                    _c("p", { staticClass: "label__text" }, [
                      _vm._v("Medlemsrabat"),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.product.sold_out !== "present" &&
              _vm.product.luxus === "present"
                ? _c("div", { staticClass: "label luxus" }, [
                    _c("p", { staticClass: "label__text" }, [_vm._v("Luxus")]),
                  ])
                : _vm.product.petlux === "present"
                ? _c("div", { staticClass: "label petlux" }, [
                    _c("p", { staticClass: "label__text" }, [_vm._v("PETLUX")]),
                  ])
                : _vm.product.sustainable === "present"
                ? _c("div", { staticClass: "label sustainable" }, [
                    _c("p", { staticClass: "label__text" }, [
                      _vm._v("Bæredygtigt"),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ProductItem__Info ProductItem__Info--left" },
              [
                _c("div", { staticClass: "ProductItem__Vendor-Wishlist" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "ProductItem__Vendor font-size-10 font-weight-500",
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.product.vendor) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("button", {
                    class:
                      "swym-button swym-add-to-wishlist-view-product product_" +
                      _vm.product.id,
                    attrs: {
                      "data-with-epi": "true",
                      "data-swaction": "addToWishlist",
                      "data-product-id": _vm.product.id_json,
                      "data-variant-id": _vm.product.variant,
                      "data-product-url":
                        _vm.product.shop_url + _vm.product.wishlist_url,
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "h2",
                  {
                    staticClass:
                      "ProductItem__Title font-size-12 font-weight-300",
                  },
                  [
                    _c("a", { attrs: { href: _vm.product.url } }, [
                      _vm._v(_vm._s(_vm.product.title)),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ProductItem__PriceList" }, [
                  _c(
                    "span",
                    {
                      staticClass:
                        "ProductItem__Price Price font-size-12 font-weight-600",
                    },
                    [_vm._v(_vm._s(_vm.product.price) + "\n        ")]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }